export const translations = {
  COMMON: {
    WELCOME: 'LIVES Antragsannahme',
  }
};
